import { r as p, s as t, m as A, p as I } from "./variables-w7y_zhbo.js";
var L = ((r) => (r[r.DEFAULT = parseInt(p, 10)] = "DEFAULT", r[r.MEDIUM = parseInt(t, 10)] = "MEDIUM", r[r.LARGE = parseInt(A, 10)] = "LARGE", r[r.XLARGE = parseInt(I, 10)] = "XLARGE", r))(L || {});
export {
  L as M
};
